import React from 'react';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { comparison, mechanism, needs } from '../data/content';
export function SolutionSection() {
  return <section className="bg-night" data-id="element-173" data-mp="3abvovpxqy7zs">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-6 lg:py-24" data-id="element-174" data-mp="3o9kbb27gpn6y">
        <div className="mx-auto max-w-3xl text-center" data-id="element-175" data-mp="3ja7dxniysxq4">
          <h2 className="font-display text-[1.875rem] font-semibold leading-tight tracking-tight text-parchment sm:text-[2.6rem]" data-id="element-176" data-mp="3j8mjrz0kbgss">
            {mechanism.title}
          </h2>
          <p className="mx-auto mt-5 max-w-2xl font-sans text-base leading-relaxed text-parchment/75 sm:text-lg" data-id="element-177" data-mp="3t7c2fu0a95a3">
            {mechanism.description}
          </p>

          <p className="mt-8 font-sans text-sm font-medium text-parchment/60" data-id="element-178" data-mp="5vb06aewakbn">
            {mechanism.needsLabel}
          </p>
          <ul className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-179" data-mp="krsf1bmamh2y">
            {needs.map(need => <li key={need.label} className="flex items-center gap-2 rounded-full border border-night-line bg-night-panel px-3.5 py-2" data-id="element-180" data-mp="fujtr25ulwxh">
                <span aria-hidden="true" className="h-2 w-2 rounded-full" style={{
              backgroundColor: need.color
            }} data-id="element-181" data-mp="3b974blvlrhse" />
                <span className="font-sans text-sm font-medium text-parchment/85" data-id="element-182" data-mp="3ka5aa9plpzdm">
                  {need.label}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="mx-auto mt-14 grid max-w-4xl gap-4 md:grid-cols-2" data-id="element-183" data-mp="3u8ba8lrukvfu">
          <div className="rounded-2xl border border-night-line bg-night-panel/60 p-6 sm:p-7" data-id="element-184" data-mp="3u687r29id9u8">
            <h3 className="font-sans text-sm font-semibold uppercase tracking-[0.12em] text-parchment/55" data-id="element-185" data-mp="2w00tm6xle0y">
              {comparison.looseTitle}
            </h3>
            <ul className="mt-5 space-y-4" data-id="element-186" data-mp="bvwllcq79sqq">
              {comparison.loose.map(item => <li key={item} className="flex gap-3" data-id="element-187" data-mp="gupzv7db9nry">
                  <MinusIcon className="mt-1 h-4 w-4 flex-none text-parchment/35" aria-hidden="true" data-id="element-188" data-mp="2cwt4jla1lt4f" />
                  <span className="font-sans text-[0.95rem] leading-relaxed text-parchment/60" data-id="element-189" data-mp="27xq5qiknoj4w">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border border-gold-soft/50 bg-gold/10 p-6 sm:p-7" data-id="element-190" data-mp="2hve37g9nc4qr">
            <h3 className="font-sans text-sm font-semibold uppercase tracking-[0.12em] text-gold-soft" data-id="element-191" data-mp="2vn127nuz3rd8">
              {comparison.kitTitle}
            </h3>
            <ul className="mt-5 space-y-4" data-id="element-192" data-mp="2rlfusi17k5af">
              {comparison.kit.map(item => <li key={item} className="flex gap-3" data-id="element-193" data-mp="35kyrmeokju7f">
                  <CheckIcon className="mt-1 h-4 w-4 flex-none text-gold-soft" aria-hidden="true" data-id="element-194" data-mp="30lvwblye52cn" />
                  <span className="font-sans text-[0.95rem] font-medium leading-relaxed text-parchment" data-id="element-195" data-mp="1b6xrlqha915r">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-12 max-w-2xl text-center font-display text-xl font-medium italic leading-snug text-gold-soft sm:text-2xl" data-id="element-196" data-mp="3hw83o84j4zwr">
          {mechanism.closing}
        </p>
      </div>
    </section>;
}